
import React, { createContext, forwardRef, useContext, useEffect, useRef, useState, } from "react";
import { Row, Col, Button, Typography, Divider, BaseChart1, BaseChart2, BaseChart3, BaseChart4 } from '../ui/ot'
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../ui/card'
import { BarChart3, PieChart, Info } from "lucide-react";
const BaseChart = ({
    title = "範本統計",
    subtitle = "範本分類與建立方式統計",
    primaryTheme="indigo",
    secondaryTheme="purple",
    baseChart1Value = {
        title: "分類與建立方式分佈",
        data: [
            {
                title: "行銷",
                data: [
                    { label: "手動", value: 8, color: "text-blue-600", bgColor: "bg-blue-500" },
                    { label: "系統", value: 12, color: "text-purple-600", bgColor: "bg-purple-500" },
                    { label: "智慧", value: 4, color: "text-blue-600", bgColor: "bg-blue-600" },
                ]
            },
            {
                title: "銷售",
                data: [
                    { label: "手動", value: 8, color: "text-blue-600", bgColor: "bg-blue-500" },
                    { label: "系統", value: 12, color: "text-purple-600", bgColor: "bg-purple-500" },
                    { label: "智慧", value: 4, color: "text-blue-600", bgColor: "bg-blue-600" },
                ]
            },
            {
                title: "報告",
                data: [
                    { label: "手動", value: 8, color: "text-blue-600", bgColor: "bg-blue-500" },
                    { label: "系統", value: 12, color: "text-purple-600", bgColor: "bg-purple-500" },
                    { label: "智慧", value: 4, color: "text-blue-600", bgColor: "bg-blue-600" },
                ]
            },
        ],
    },
    baseChart2Value = {
        title: "範本總覽",
        stats: [
            {
                value: 125847,
                label: "範本總量",
                color: "#3b82f6",
                backgroundColor: "bg-blue-50",
                animationDuration: 2000,
                animationDelay: 0,
            },
            {
                value: 5,
                label: "服務分館",
                color: "#10b981",
                backgroundColor: "bg-green-50",
                animationDuration: 1500,
                animationDelay: 200,
            },
        ]
    },
    baseChart3Value = {
        title: "建立方式",
        items: [
            { label: "手動建立", value: 28, colorClass: "bg-blue-500" },
            { label: "系統範本", value: 45, colorClass: "bg-purple-500" },
            { label: "智慧生成", value: 17, colorClass: "bg-indigo-500" },
        ]
    },
    baseChart4Value = {
        title: "建立方式",
        chartData: [
            { source: "manual", count: 28 },
            { source: "system", count: 45 },
            { source: "ai", count: 17 },
        ],
        chartConfig: {
            manual: { label: "手動建立", color: "hsl(var(--chart-1))" },
            system: { label: "系統範本", color: "hsl(var(--chart-2))" },
            ai: { label: "智慧生成", color: "hsl(var(--chart-3))" },
        },
        xDataKeyArr: ["source"],
        yDataKeyArr: ["count"]
    },
}) => {
    const [activeChartType, setActiveChartType] = useState("bar") // <"bar" | "pie">
    return (<>
        <div className="lg:col-span-1 stats-panel">
            <Card className={`border-${primaryTheme}-200 shadow-md sticky top-4`}>
                <CardHeader className={`bg-gradient-to-r from-${primaryTheme}-50 to-${secondaryTheme}-50 border-b border-${primaryTheme}-100`}>
                    <div className="flex justify-between items-center">
                        <CardTitle className={`text-${primaryTheme}-800 text-lg`}>{title}</CardTitle>
                        <div className="flex space-x-1">
                            <Button
                                variant="ghost"
                                size="sm"
                                className={`p-1 h-7 w-7 ${activeChartType === "bar" ? `bg-${primaryTheme}-100` : ""}`}
                                onClick={() => setActiveChartType("bar")}
                            >
                                <BarChart3 className="h-4 w-4" />
                            </Button>
                            <Button
                                variant="ghost"
                                size="sm"
                                className={`p-1 h-7 w-7 ${activeChartType === "pie" ? `bg-${primaryTheme}-100` : ""}`}
                                onClick={() => setActiveChartType("pie")}
                            >
                                <PieChart className="h-4 w-4" />
                            </Button>
                        </div>
                    </div>
                    <CardDescription className={`text-${primaryTheme}-600`}>{subtitle}</CardDescription>
                </CardHeader>
                <CardContent className="p-4">
                    <div className="space-y-6">
                        {activeChartType === "bar" ? (
                            <div>
                                <BaseChart1
                                    {...baseChart1Value}
                                />
                            </div>
                        ) : (
                            <div>
                                <h3 className="text-sm font-medium mb-3 flex items-center justify-center">
                                    <span className={`text-${primaryTheme}-700`}>{baseChart4Value?.title}</span>
                                    <Info className="h-3.5 w-3.5 ml-1 text-muted-foreground" />
                                </h3>
                                <BaseChart4
                                    {...baseChart4Value}
                                    labelType="none"
                                    innerRadius={0}
                                    showLegend={true}
                                    legendLayout="horizontal"
                                />
                            </div>
                        )}
                    </div>
                    <Divider />
                    <BaseChart2
                        layout="horizontal"
                        contentAlign="center"
                        baseStatsCard={{
                            title: "範本總覽",
                            stats: [
                                {
                                    value: 1258,
                                    label: "範本總量",
                                    color: "#3b82f6",
                                    backgroundColor: "bg-blue-50",
                                    animationDuration: 2000,
                                    animationDelay: 0,
                                },
                                {
                                    value: 5,
                                    label: "服務分館",
                                    color: "#10b981",
                                    backgroundColor: "bg-green-50",
                                    animationDuration: 1500,
                                    animationDelay: 200,
                                },
                            ],
                            responsiveColumns: { sm: 1, md: 1, lg: 2, xl: 2, xxl: 2 }
                        }}
                        connection="separated"
                        size="sm"
                        enableAnimation={false}
                        {...baseChart2Value}
                    />
                    <Divider />
                    <BaseChart3
                        {...baseChart3Value}
                    />
                </CardContent>
            </Card>
        </div>

    </>)
}
export default BaseChart